import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService } from '@openng/optimus-ui/api';
import { errorInterceptor } from './error.interceptor';

export function provideErrorHandling(): EnvironmentProviders {
  return makeEnvironmentProviders([
    MessageService,
    provideHttpClient(withInterceptors([errorInterceptor])),
  ]);
}
